import { EventHandler, ReactNode, useState } from 'react';
import { IconAlertCircleFill, IconEye, IconEyeStrike } from '../Icon';
import { cn } from '../../lib/helpers.ts';

interface FormInputProps {
    name: string;
    label: string | ReactNode;
    onChange: EventHandler<never>; // TODO: change
    onBlur: EventHandler<never>; // TODO: change
    value: string; // TODO: check
    type: string;
    placeholder?: string;
    autofocus?: boolean;
    labelChildren?: ReactNode;
    error?: string | null;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    tabIndex?: number;
}

export default function FormInput({
    name,
    label,
    onChange,
    onBlur,
    value,
    type,
    labelChildren,
    placeholder,
    autofocus,
    error,
    required,
    disabled,
    readonly,
    tabIndex,
}: FormInputProps) {
    const [passwordDisplayed, setPasswordDisplayed] = useState(false);
    const PasswordDisplayIcon = passwordDisplayed ? IconEyeStrike : IconEye;

    return (
        <div className={cn('w-full', type === 'hidden' && '!mt-0')}>
            {(!!label || !!labelChildren) && type !== 'hidden' ? (
                <div className="mb-2 flex w-full items-center justify-between">
                    <label htmlFor={name} className="block font-medium">
                        {label}{' '}
                        {required && <span className="text-red-500">*</span>}
                    </label>
                    {labelChildren}
                </div>
            ) : null}
            <div className="relative">
                <input
                    className={cn(
                        'w-full rounded-xl border-cloud-300 bg-cloud-200 px-4 py-3 font-sans text-base',
                        'autofill:font-sans autofill:text-base',
                        error && 'border-2 border-red-500',
                        disabled && 'text-ink-800'
                    )}
                    autoFocus={autofocus}
                    type={
                        passwordDisplayed && type === 'password' ? 'text' : type
                    }
                    disabled={disabled}
                    readOnly={readonly}
                    onChange={onChange}
                    onBlur={onBlur}
                    id={name}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    required={required}
                    tabIndex={tabIndex}
                />

                {type === 'password' && (
                    <button
                        className="absolute bottom-0 right-[14px] top-0"
                        type="button"
                        onClick={() =>
                            setPasswordDisplayed((current) => !current)
                        }
                    >
                        <PasswordDisplayIcon
                            size={24}
                            className="text-ink-800"
                        />
                    </button>
                )}
            </div>
            {error && (
                <div className="mt-2 flex space-x-2.5 font-medium text-red-500">
                    <IconAlertCircleFill size={20} className="shrink-0" />
                    <p>{error}</p>
                </div>
            )}
        </div>
    );
}
